/* eslint-disable */

import {$t} from '@/i18n';
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

export async function sendEmail(mailData){

  if(!mailData.from){
    mailData.from = "ubiflow@ubiflow.net"
  }

  let params = {
    data: mailData
  };

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/mail/send', mailData, params)
    .then(response => {
      return {type: "success", message: $t("contact.messageEmailSent")};
    })
    .catch(error => {
      return {type: "error", message: $t("contact.messageEmailError")};
    })
}



